import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { SlackIcon } from "simplydo/react/ui/brand-icon";
import { Card, CardContent } from "simplydo/react/ui/card";
import { Grid, GridColumn } from "simplydo/react/ui/grid";
import { H2, H3 } from "simplydo/react/ui/header";
import { IconData } from "simplydo/react/ui/icon";
import { Loader } from "simplydo/react/ui/loader";
import { Message } from "simplydo/react/ui/message";

import util from "utils/utils";

type OAuthConnectionType = { Icon: IconData; name: string };

const types: Record<string, OAuthConnectionType> = {
  slack: { Icon: SlackIcon, name: "Slack" },
};

const OAuthConnection = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [type, setType] = useState<OAuthConnectionType | null>(null);

  const params = useParams();

  useEffect(() => {
    const connectionType = params.type;
    if (!connectionType || !types[connectionType]) {
      setErrorMessage("Connections with this service are not supported.");
    } else {
      const nextType = types[connectionType];
      setType(nextType);
      setLoading(true);
    }
  }, [params.type]);

  const Brand = type?.Icon;

  return (
    <Grid mobile={1} columns={16} style={{ marginTop: 40 }}>
      <GridColumn span={16} computer={6} tablet={10}>
        <Card fluid color="yellow">
          {type && Brand ? (
            <CardContent style={{ paddingTop: 20, textAlign: "center" }}>
              <Brand size={40} />
              <H3 style={{ marginTop: 10 }}>
                Adding {type.name} to your {util.appName()} account...
              </H3>
            </CardContent>
          ) : null}
          {loading ? (
            <CardContent>
              <Loader />
            </CardContent>
          ) : null}
          {!loading && errorMessage ? (
            <CardContent>
              <Message color="red">{errorMessage}</Message>
            </CardContent>
          ) : (
            <React.Fragment>
              <CardContent>
                <H2>Done</H2>
              </CardContent>
            </React.Fragment>
          )}
        </Card>
      </GridColumn>
    </Grid>
  );
};

export default OAuthConnection;
